// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"fed0bbdc","97":"257a1db6","207":"d909dc27","488":"4ede2a20","508":"5cd43c15","542":"8c566735","552":"47447b7c","583":"89c77cf8","632":"ececff8b","741":"d32a5a0a","745":"ae1e32b1","947":"d484c239"}[chunkId] + ".chunk.js";
};